export const GET_STATES_AND_CITIES = 'GET_STATES_AND_CITIES';
export const PUT_CURRENT_CITIES = 'PUT_CURRENT_CITIES';
export const GET_STATES_AND_CITIES_SUCCESS = 'GET_STATES_AND_CITIES_SUCCESS';
export const GET_STATES_AND_CITIES_ERROR = 'GET_STATES_AND_CITIES_ERROR';
